/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardAbsenceDto } from './DashboardAbsenceDto';
import {
    DashboardAbsenceDtoFromJSON,
    DashboardAbsenceDtoFromJSONTyped,
    DashboardAbsenceDtoToJSON,
} from './DashboardAbsenceDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DashboardAbsenceDtoPaginatedResults
 */
export interface DashboardAbsenceDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DashboardAbsenceDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DashboardAbsenceDto>}
     * @memberof DashboardAbsenceDtoPaginatedResults
     */
    results?: Array<DashboardAbsenceDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DashboardAbsenceDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DashboardAbsenceDtoPaginatedResults interface.
 */
export function instanceOfDashboardAbsenceDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardAbsenceDtoPaginatedResultsFromJSON(json: any): DashboardAbsenceDtoPaginatedResults {
    return DashboardAbsenceDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DashboardAbsenceDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAbsenceDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DashboardAbsenceDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DashboardAbsenceDtoPaginatedResultsToJSON(value?: DashboardAbsenceDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DashboardAbsenceDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

